<div
    class="profile-foldout tw-flex tw-flex-col tw-gap-2"
    [attr.aria-label]="'navigation.profile.foldout.ariaLabel' | transloco"
    data-test="navigation-profile-foldout"
>
    <div class="profile-foldout__header tw-flex tw-items-center tw-gap-2 tw-px-4" data-test="navigation-profile-foldout-header">
        <p-avatar
            [label]="getAvatarInitials()"
            shape="circle"
            size="large"
            styleClass="profile-foldout__avatar"
            data-test="navigation-profile-foldout-avatar"
        />
        <div class="profile-foldout__user-info tw-flex tw-flex-col tw-gap-1">
            <span class="profile-foldout__name" data-test="navigation-profile-foldout-name">{{ getFullName() }}</span>
            <span class="profile-foldout__email" data-test="navigation-profile-foldout-email">{{ user?.email }}</span>
            <span class="profile-foldout__organization" data-test="navigation-profile-foldout-organization">{{ getOrganization() }}</span>
        </div>
    </div>

    <p-menu [model]="menuItems" styleClass="profile-foldout__menu" data-test="navigation-profile-foldout-menu" />
</div>
